var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcons8IphoneX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "96px",
    height: "96px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 16.5 4 C 13.480226 4 11 6.4802259 11 9.5 L 11 38.5 C 11 41.519774 13.480226 44 16.5 44 L 31.5 44 C 34.519774 44 37 41.519774 37 38.5 L 37 9.5 C 37 6.4802259 34.519774 4 31.5 4 L 29.050781 4 L 19 4 L 16.5 4 z M 16.5 7 L 18.074219 7 L 18.658203 8.1699219 A 1.50015 1.50015 0 0 0 20 9 L 28 9 A 1.50015 1.50015 0 0 0 29.341797 8.1699219 L 29.925781 7 L 31.5 7 C 32.898226 7 34 8.1017741 34 9.5 L 34 38.5 C 34 39.898226 32.898226 41 31.5 41 L 16.5 41 C 15.101774 41 14 39.898226 14 38.5 L 14 9.5 C 14 8.1017741 15.101774 7 16.5 7 z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8IphoneX);
export default __webpack_public_path__ + "static/media/icons8-iphone-x.1f08eb906e180147ff4bc15990982030.svg";
export { ForwardRef as ReactComponent };